<template>
  <div>
    <img
      src="../../assets/img/egresa-do-full-white.svg"
      class="logo mb-5"
      alt
    >
    <h2 class="do-h2 text-white">
      ¡CUENTANOS DE TI!
    </h2>
    <p
      class="do-p text-white mb-5"
    >
      Con tu RNE podemos cargar directamente tu información
      y pasar a la exploración de carreras más rápido.
    </p>

    <form
      @submit.prevent="onRNESubmit"
    >
      <div class="form-group">
        <label
          for="tellussaboutyourself-email"
          style="font-size: 1.2em;"
          class="text-white"
        >Coloca tu código RNE:</label>
        <input
          id="tellussaboutyourself-email"
          v-model="rne"
          type="text"
          name="tellussaboutyourself-email"
          class="form-control"
          required
        >

        <p class="form-text text-white">
          <small>
            ¿No tienes código RNE?, <a
              href="#"
              class="text-white"
              @click.prevent.stop="noRNE"
            ><u>realizar sin RNE</u>
            </a>
          </small>
        </p>
      </div>
      <button
        class="continue-btn"
        :disabled="submitButtonDisabled"
        type="submit"
      >
        Continuar <img
          src="../../assets/continue-icon.svg"
          alt=""
        >
      </button>
    </form>
  </div>
</template>

<script>
import store from '../../_store';
import { studentsService } from '../../_services';

export default {
    name: 'TellUsAboutYourself',
    data() {
        return {
            rne: '',
            submitButtonDisabled: false,
        };
    },
    methods: {
        noRNE() {
            //  store.commit('authentication/clearStaticData');
            store.dispatch('loginDialog/setDialogWithProps', {
                dialog: 'VerifyStudentData',
                props: { rne: this.rne },
            });
        },
        setButtonDisabled(disabledStatus) {
            return new Promise((resolve) => {
                this.submitButtonDisabled = (typeof disabledStatus !== 'undefined')
                    ? !!disabledStatus : !this.submitButtonDisabled;
                resolve();
            });
        },
        onRNESubmit(e) {
            if (!e.target.checkValidity()) {
                e.stopPropagation();
            } else {
                this.setButtonDisabled(true)
                    .then(() => studentsService.postStaticStudentRNE({
                        email: store.getters['authentication/student_data'].username,
                        rne: this.rne,
                    }))
                    .then((response) => {
                        store.commit('authentication/linkStaticData', response.data);
                        store.commit('loginDialog/setCurrentDialog', 'VerifyStudentData');
                    })
                    .catch((error) => {
                        e.stopPropagation();
                        throw new Error(`Problem with handling something: ${error}`);
                    })
                    .finally(() => {
                        this.setButtonDisabled(false);
                    });
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.continue-btn{
  position: absolute;
  right: 20px;
  bottom: 20px;
  background: none;
  border: none;
  text-transform: uppercase;
  color: white;
  font-family: Montserrat;
  font-size: 13px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.92;
  letter-spacing: 0.35px;
  text-align: left;
  display: flex;
  align-items: center;
  img{
    margin-left: 0.5rem;
  }
}
</style>
